import React, { useState,useContext, useEffect } from 'react'
import './Problem.css'
import { useNavigate } from 'react-router-dom'
import {AuthContext} from '../../context/authContext'
import { renderStatementWithKaTeX } from '../../Functions/WriteLaTex';
const Problem = ({problem, PassDue}) => {
 const navigate=useNavigate()
 const {user}=useContext(AuthContext)
 const [ShowLatexCode, setShowLatexCode] = useState(false)
  return (
<div className="pod-container">
      <h2 className="pod-heading" style={{color : "#156874"}}>{problem?.type==="Daily"?"🔍 Problem of the Day :":problem?.type==="Unit"?`🔍 Unit Problem :`:"🔍 Problem of the Weel"}#{problem?.referenceCode}</h2>

      <div className="pod-content">
        <div className="pod-tags">
          <span className={`pod-difficulty ${problem?.difficulty.toLowerCase()}`}>
            {problem?.difficulty}
          </span>
          {/* {problem?.tags.map((tag, index) => (
            <span className="pod-tag" key={index}>{tag}</span>
          ))} */}
          <span className="pod-field" >{problem?.field}</span>
          <span className="pod-source">{problem?.source}</span>
        </div>
        <h3 className="pod-title">
            {ShowLatexCode?<p>{problem?.statement}</p>:renderStatementWithKaTeX(problem?.statement)}
        </h3>
        <p className="pod-meta">Posted on {new Date(problem?.postedAt).toLocaleString()} by {problem?.author}</p>

        {PassDue?(
        <div className="ShowSolution">
         {/*  <h3>This problem was Solved by : {} Students</h3> */}
<button onClick={() => setShowLatexCode(prev => !prev)}>
  {ShowLatexCode ? "Normal Format" : "LaTeX Format"}
</button>        </div>
          ):( <div className='pod-buttons-conatiner'>
        <button  className="pod-button-SC" onClick={()=>navigate('../../Report')}>Report Problem </button>
          {user?.role.trim().toLowerCase()==="student"?<button className="pod-button-SW" onClick={()=>navigate(`../Submission/${problem?.referenceCode}`)}>Submit Work</button>:<button className="pod-button-SW" onClick={()=>navigate(`../Dashboard`)}>Edit Problem</button>}
          </div>)}
         
      </div>
    </div>
  )
}

export default Problem
